import axios from "axios";

export const RETRY_DELAYS = [1000, 2000, 3000];
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

// No reply at all (dropped Wi-Fi, school filter, server restarting), as opposed to the server saying no.
export const unreachable = (e) => axios.isAxiosError(e) && !e.response;

export const unreachableHelp = () => {
  const host = new URL(process.env.REACT_APP_BACKEND_URL).hostname;
  return `Couldn't reach HubPilot to prepare your robot. Check your internet connection and try again. On a school network, ask IT to allow ${host}.`;
};

export async function compileWithRetry(api, code, onRetry, delays = RETRY_DELAYS) {
  for (let attempt = 0; ; attempt += 1) {
    try {
      return await api.post("/compile", { code });
    } catch (e) {
      if (!unreachable(e) || attempt === delays.length) throw e;
      onRetry(attempt + 1, delays.length);
      await sleep(delays[attempt]);
    }
  }
}
